import TextLoading from '@/app/common/components/skeleton/TextLoading';
import type { ModalSize } from '@/app/KeywordTracker/types/aiModalTypes';
import Flex from '@/components/common/Flex';
import classNames from 'classnames';
import { Card } from 'react-bootstrap';
import SimpleBarReact from 'simplebar-react';

interface ChatPreloadItemProps {
  isUser: boolean;
  widths: Array<number | string>;
  delay: number;
}

const ChatPreloadItem = ({ isUser, widths, delay }: ChatPreloadItemProps) => {
  const isOwner = isUser;

  return (
    <div
      className="ai-chat-preload-item"
      style={{ animationDelay: `${delay}s` }}
    >
      <Flex className="p-1 pb-3 mx-2">
        <div
          className={classNames('flex-1 mx-2', {
            'd-flex justify-content-end': !isOwner
          })}
          style={{ maxWidth: '100%', marginTop: '-2px' }}
        >
          <div
            style={{
              width: '95%',
              maxWidth: '1200px',
              minWidth: '300px'
            }}
          >
            <div
              className={classNames('rounded-2 ai-chat-preload-bubble', {
                'ai-chat-preload-bubble-user': isOwner,
                'ai-chat-preload-bubble-ai': !isOwner
              })}
            >
              {widths.map((width, index) => (
                <div key={index} className={index > 0 ? 'mt-2' : undefined}>
                  <TextLoading
                    width={width}
                    height={10}
                    isWidthPx={typeof width === 'number'}
                  />
                </div>
              ))}
            </div>

            <Flex
              className={classNames('mt-2 gap-2', {
                'justify-content-end': !isOwner
              })}
            >
              <TextLoading width={56} height={8} isWidthPx />
              <TextLoading width={72} height={8} isWidthPx />
            </Flex>
          </div>
        </div>

        {!isOwner && (
          <div className="ai-chat-preload-avatar">
            <TextLoading width={40} height={40} isWidthPx />
          </div>
        )}
      </Flex>
    </div>
  );
};

interface ChatPreloadProps {
  isMdUp: boolean;
  size: ModalSize;
}

const preloadMessages: Array<{
  isUser: boolean;
  widths: Array<number | string>;
}> = [
  { isUser: true, widths: [180, 120] },
  { isUser: false, widths: ['100%', '92%', '78%', 210] },
  { isUser: true, widths: [140] },
  { isUser: false, widths: ['85%', '70%'] }
];

const ChatPreload = ({ isMdUp, size }: ChatPreloadProps) => (
  <Card.Body as={Flex} className="p-0 flex-1">
    <SimpleBarReact
      style={{
        height: isMdUp ? size.height - 180 : 'calc(85vh - 180px)',
        width: '100%'
      }}
    >
      <div className="chat-content-scroll-area mt-3 ai-chat-preload">
        {preloadMessages.map((item, index) => (
          <ChatPreloadItem
            key={index}
            isUser={item.isUser}
            widths={item.widths}
            delay={index * 0.12}
          />
        ))}
      </div>
    </SimpleBarReact>
  </Card.Body>
);

export default ChatPreload;
